import {
  CaretRight,
  ChartLine,
  Clock,
  FileText,
  Folder,
  House,
  ListBullets,
  Package,
  ShoppingCart,
  Star,
} from '@phosphor-icons/react';
import { useState } from 'react';

import { ExpandIcon, MenuContainer, MenuHeader, MenuItem, MenuSection } from './styles';

export const LeftMenu = () => {
  const [expandedSections, setExpandedSections] = useState({
    quotes: true,
    orders: false,
  });

  const toggleSection = (section: string) => {
    setExpandedSections((prev) => ({
      ...prev,
      [section]: !prev[section],
    }));
  };

  return (
    <MenuContainer>
      <MenuSection>
        <MenuItem>
          <Clock size={10} />
          Recent
        </MenuItem>
        <MenuItem>
          <Star size={10} />
          Pinned
        </MenuItem>
      </MenuSection>

      <MenuSection>
        <MenuHeader>Home</MenuHeader>
        <MenuItem>
          <House size={10} />
          Home
        </MenuItem>
      </MenuSection>

      <MenuSection>
        <MenuHeader>Reports/Dashboards</MenuHeader>
        <MenuItem>
          <ChartLine size={10} />
          Dashboards
        </MenuItem>
      </MenuSection>

      <MenuSection>
        <MenuHeader>Quotes</MenuHeader>
        <MenuItem active onClick={() => toggleSection('quotes')}>
          <ExpandIcon expanded={expandedSections.quotes}>
            <CaretRight size={8} weight="bold" />
          </ExpandIcon>
          <ListBullets size={10} />
          Quote Summary
        </MenuItem>
        {expandedSections.quotes && (
          <>
            <MenuItem indent>Quote Lines</MenuItem>
            <MenuItem indent>Create Quote</MenuItem>
          </>
        )}
      </MenuSection>

      <MenuSection>
        <MenuHeader>Orders</MenuHeader>
        <MenuItem onClick={() => toggleSection('orders')}>
          <ExpandIcon expanded={expandedSections.orders}>
            <CaretRight size={8} weight="bold" />
          </ExpandIcon>
          <Package size={10} />
          Order Summary
        </MenuItem>
        {expandedSections.orders && (
          <>
            <MenuItem indent>Order Lines</MenuItem>
            <MenuItem indent>Create Order</MenuItem>
            <MenuItem indent>Create Return</MenuItem>
          </>
        )}
      </MenuSection>

      <MenuSection>
        <MenuHeader>Order Invoices</MenuHeader>
        <MenuItem>
          <FileText size={10} />
          Invoice Summary
        </MenuItem>
      </MenuSection>

      <MenuSection>
        <MenuHeader>Value-Add Services (VAS)</MenuHeader>
        <MenuItem>
          <Folder size={10} />
          Create VAS
        </MenuItem>
      </MenuSection>

      <MenuSection>
        <MenuItem>
          <ShoppingCart size={10} />
          Quote and Order...
        </MenuItem>
      </MenuSection>
    </MenuContainer>
  );
};
